import { render } from "./CommissionsPackagesView.vue?vue&type=template&id=153b42e3&scoped=true"
import script from "./CommissionsPackagesView.vue?vue&type=script&lang=js"
export * from "./CommissionsPackagesView.vue?vue&type=script&lang=js"

import "./CommissionsPackagesView.vue?vue&type=style&index=0&id=153b42e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153b42e3"]])

export default __exports__